import {createContext} from 'react';
import {IGetReviewsRequest, TGetReviewsTransformedResponse} from 'modules/product-card/models/Review';
import {ISelectOption} from 'components/InputSelect';
import {ESortingActions} from 'modules/products/providers/CatalogPageProvider/types';

export interface IPickupModalContext {
    data: TGetReviewsTransformedResponse | undefined;
    getReviews: (newParams: Partial<IGetReviewsRequest>) => void;
    onSortClick: (sortOption: ISelectOption<ESortingActions>) => void;
    createOnFilterClickHandler: (value: number) => () => void;
    isLoading: boolean;
}

export const ProductReviewContext = createContext<IPickupModalContext>({
    data: undefined,
    getReviews: (_) => {
        throw new Error('getReviews not implemented');
    },
    onSortClick: () => {
        throw new Error('onSortClick not implemented');
    },
    createOnFilterClickHandler: () => () => {
        throw new Error('createOnFilterClickHandler not implemented');
    },
    isLoading: false,
});
